import React from 'react';
import PropTypes from 'prop-types';
import { Container, Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import FadeIn from 'react-fade-in';
import { useTranslation } from 'react-i18next';
import Page from 'src/components/Page';
import { CapitalBalanceSummaryList } from './CapitalBalanceSummaryList';
import CapitalBalanceSummaryToolbar from './CapitalBalanceSummaryToolbar';

const useStyles = makeStyles()(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const CapitalBalanceSummaryView = ({ config }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Page className={classes.root} title={t(config.summaryTitleKey)}>
      <FadeIn transitionDuration={200}>
        <Container maxWidth={false}>
          <CapitalBalanceSummaryToolbar
            titleKey={config.summaryTitleKey}
          />
          <Box mt={3}>
            <CapitalBalanceSummaryList config={config} />
          </Box>
        </Container>
      </FadeIn>
    </Page>
  );
};

CapitalBalanceSummaryView.propTypes = {
  config: PropTypes.object.isRequired,
};

export default CapitalBalanceSummaryView;

